import {
  TAX_SAVER_PLANS,
  GOAL_BASED,
  POPULAR,
  SUITABLE_PLANS,
} from './fundBuckets/';

export {
  HOME_PAGE_ALTERNATE_CARDS,
  HOME_PAGE_WHY_US_SECTION_CONTENT,
  HOME_PAGE_NFO_SECTION_CONTENT,
} from './homePageStatic';

export const bucketLists = [
  // first seciton starts
  {
    type: 'single',
    title: 'Investments made simple',
    description: 'By ClearTax, trusted by <span>25 Lakh Indians</span>',
    points: [
      {
        title: 'Free, simple and safe',
      },
      {
        title: 'Start with as low as Rs.500',
      },
      {
        title: 'Expert picked funds for you',
      },
    ],
    card: TAX_SAVER_PLANS,
  },
  // next section starts
  {
    type: 'multiple',
    title: 'Most Popular Plans',
    subTitle: 'Plans most popular with smart investors',
    image: 'piggy_one.svg',
    coloredBackground: true,
    cards: POPULAR,
  },
  // next section starts
  {
    type: 'multiple',
    title: 'Plans that may suit you',
    subTitle:
      'We all walk in different shoes. These plans are tailored right for the person you are.',
    image: 'piggy_three.svg',
    coloredBackground: false,
    cards: SUITABLE_PLANS,
  },
];

export const buckets = [].concat(
  TAX_SAVER_PLANS,
  POPULAR,
  GOAL_BASED,
  SUITABLE_PLANS
);



// WEBPACK FOOTER //
// ./constants/homePageData.ts